import { useTranslation } from "react-i18next";

export default function PricingHero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-deepblack"
    >
      {/* Ambient background glow */}
      <div className="absolute inset-0">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-champagne/5 blur-[120px]" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 text-center">
        {t("pricing.hero.tag") && (
          <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-10"
          >
            {t("pricing.hero.tag")}
          </span>
        )}

        {/* From Zero to One branding */}
        <div className="mb-6">
          <p className="text-marble/40 text-sm md:text-base font-sans tracking-widest uppercase mb-3">
            {t("pricing.hero.brand1")}
          </p>
          <h2 className="font-serif text-marble leading-none">
            <span className="block text-6xl md:text-8xl lg:text-9xl font-light tracking-wide">
              {t("pricing.hero.brand2")}
            </span>
            <span className="block text-2xl md:text-3xl font-light tracking-widest text-champagne mt-2">
              {t("pricing.hero.brand3")}
            </span>
            <span className="block text-6xl md:text-8xl lg:text-9xl font-light tracking-wide mt-1">
              {t("pricing.hero.brand4")}
            </span>
          </h2>
        </div>

        {/* 会員制・紹介制 — standout badge */}
        <div className="mb-8">
          <span className="inline-block px-6 py-3 bg-champagne/15 border-2 border-champagne/50 rounded-full text-champagne text-sm md:text-base font-sans tracking-widest animate-pulse">
            {t("pricing.hero.membership")}
          </span>
        </div>

        {/* Program label — BIG yellow standout */}
        <div className="relative inline-block bg-champagne/10 rounded-2xl border border-champagne/40 px-6 md:px-12 py-5 md:py-7 mb-4">
          <p className="text-champagne font-serif text-sm md:text-2xl lg:text-3xl font-light tracking-wide leading-relaxed max-w-3xl whitespace-pre-line">
            {t("pricing.hero.programLabel")}
          </p>
        </div>
      </div>
    </section>
  );
}